import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Flex } from "../../../../components/layout";
import { Spinner } from "../../../../components/loader/icon";

const Wrapper = styled.div`
  text-align: center;
  margin-top: 4em;
`;

export const NoUsers = () => {
  const { t } = useTranslation("billing");
  return (
    <Flex center>
      <Wrapper>
        <p>{t("no-user-entries")}</p>
      </Wrapper>
    </Flex>
  );
};

export const AnErrorHasOccured = () => {
  const { t } = useTranslation("common");
  return (
    <Flex center>
      <Wrapper>
        <p>{t("error-has-occured")}</p>
      </Wrapper>
    </Flex>
  );
};

export const StyledSpinner = styled(Spinner)`
  width: 40px;
  height: 40px;

  &::after {
    width: 32px;
    height: 32px;
    margin: 4px;
    border-width: 3px;
  }
`;
